//  ----------      START   IMPORT  BLOCK       ----------
//  Services
import APIService from '../Core/APIService';
//  Config
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
//  ----------      END   IMPORT  BLOCK       ----------

class UserProfileOnboardingService extends APIService {

  /**
   * Transforms raw UI form data into the strict schema expected by the FastAPI backend.
   */
  _mapToSchema(data) {
    return {
      immutables: {
        blood_type: data.blood_type,
        birthday: data.birthday ? new Date(data.birthday).toISOString() : null,
        birthplace: data.birthplace,
        date_of_death: null 
      },
      contact: {
        phone_numbers: data.phone_numbers || []
      },
      // 🎯 FIX 1: API expects an array named "addresses" at the root
      addresses: [
        {
          street: data.current_address?.street || "",
          number: data.current_address?.number || "",
          interior_number: parseInt(data.current_address?.interior_number, 10) || 0,
          city: data.current_address?.city || "",
          state: data.current_address?.state || "", 
          zip_code: data.current_address?.zip_code || "",
          country: data.current_address?.country || "69a9ded54e7bf06aa8ad9ed4", // Mexico ID default fallback
          google_maps_url: data.current_address?.google_maps_url || ""
        }
      ],
      // 🎯 FIX 2: API expects "emergency_contacts" at the root level
      emergency_contacts: (data.emergency_contacts || []).map(c => ({
        name: c.name || "",
        phone: c.phone || "",
        relationship: parseInt(c.relationship, 10) || 0
      })),
      general_info: {
        height: Number(data.height) || 0,
        weight: Number(data.weight) || 0,
        marital_status: data.marital_status, 
        occupation: data.occupation || "",
        religion: data.religion,
        sex: data.sex,
        education: data.scholarship
      },
      fitness: {
        level: data.fitness?.level || "",
        frequency_per_week: data.fitness?.frequency_per_week || ""
      },
      substances: {
        has_history: Boolean(data.substances?.has_history),
        // 🎯 FIX 3: Clean empty string ("") to null for date fields like year_end
        substances_detail: (data.substances?.substances_detail || []).map(item => ({
          ...item,
          year_end: item.year_end ? item.year_end : null
        }))
      },
      diet: {
        meals_per_day: Number(data.diet?.meals_per_day) || 3,
        water_liters: data.diet?.water_liters || "",
        frequency_junk_food: data.diet?.frequency_junk_food || "",
        is_special_diet: Boolean(data.diet?.is_special_diet),
        diet_type: data.diet?.diet_type || null,
        diet: data.diet?.diet_type || null
      },
      sexual_health: {
        status: Boolean(data.sexual_health?.status),
        partners_range: data.sexual_health?.status ? data.sexual_health?.partners_range : null,
        protection: data.sexual_health?.status ? data.sexual_health?.protection : null
      }
    };
  }

  async createProfileOnboarding(rawFormData) {
    try {
      const mappedData = this._mapToSchema(rawFormData);
      console.log("🚀 Payload ready for API:", mappedData);

      return await this.post(API_ROUTES.onboarding_profile_create, mappedData);
    } catch (error) {
      console.error("Onboarding Service Error:", error);
      throw error;
    }
  }
}

const serviceInstance = new UserProfileOnboardingService();
export default serviceInstance;